import { render, staticRenderFns } from "./ServiceAssistantRow.vue?vue&type=template&id=130f04b5"
import script from "./ServiceAssistantRow.vue?vue&type=script&lang=js"
export * from "./ServiceAssistantRow.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssistantRow.vue?vue&type=style&index=0&id=130f04b5&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports